import React from "react";
import useBreakpoints from "../../hooks/useBreakpoints";
import { useWorkflowsPage } from "./WorkflowsPage.hooks";
import PageTitle from "../../components/PageTitle";
import PageTabs from "../../components/PageTabs";
import WorkflowList from "../../customComponents/WorkflowList";
import { Box, Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { Plus } from "@tiny/icons";
import useCreateWorkflow from "../../customComponents/CreateWorkflow/CreateWorkflow.hooks";
import { CreateWorkflowDialog } from "../../customComponents/CreateWorkflow/CreateWorkflow";
import { useDrawerInvokers } from "@tiny/lib";
import WorkflowTemplateSelection from "../../customComponents/WorkflowTemplateSelection/WorkflowTemplateSelection";
import { MetricCard } from "../../components";
import { useConfigView } from "../../Config.context";
import NoWorkflowsPanel from "./NoWorkflowPanel/NoWorkflowPanel";

function WorkflowsPage() {
  const { mdUp } = useBreakpoints();
  const createWorkflow = useCreateWorkflow();
  const { showDrawer } = useDrawerInvokers();
  const { config } = useConfigView();

  const {
    workflowStatuses,
    numberOfWorkflows,
    nav,
    changeTab,
    tabValue,
    open,
    handleOpenMenu,
    anchorEl,
    handleCloseMenu,
    mappedWorkflowMetrics,
    isWorkflowsLoading,
  } = useWorkflowsPage();

  const handlePredefineClick = (e: React.SyntheticEvent) => {
    handleCloseMenu();
    handlePredefinedWorkflow();
  };

  const handleAddNewWorkflow = () => {
    createWorkflow.openWorkflowDialog();
  };

  const handlePredefinedWorkflow = () => {
    showDrawer({
      children: <WorkflowTemplateSelection />,
    });
  };

  return (
    <div>
      <Box display={"flex"} justifyContent={"space-between"}>
        <PageTitle
          title={
            config?.appName === "tinyEmail" ? (
              <Typography variant="h1" m={0} color="grey.100" noWrap>
                Workflows
              </Typography>
            ) : (
              <Typography variant="h2" m={0} color="grey.100" noWrap>
                Workflows
              </Typography>
            )
          }
          actions={
            <>
              {mdUp && (
                <Button
                  id="workflows-add-new"
                  sx={{ px: 4, py: { xl: 2.5, sm: 1.5 }, pr: 3 }}
                  variant="contained"
                  endIcon={<Plus />}
                  onClick={(e) => {
                    handleOpenMenu(e);
                  }}
                >
                  Add New
                </Button>
              )}
              <Menu
                id="secondary-menu"
                anchorEl={anchorEl}
                open={open}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                onClose={handleCloseMenu}
                sx={{ mb: 6 }}
                PaperProps={{
                  style: {
                    marginTop: 4,
                  },
                }}
              >
                <MenuItem
                  data-tour="workflows-from-scratch"
                  onClick={(e) => handleAddNewWorkflow()}
                >
                  <Typography variant="p2">From Scratch</Typography>
                </MenuItem>
                <MenuItem onClick={handlePredefineClick}>
                  <Typography variant="p2">Predefined</Typography>
                </MenuItem>
              </Menu>
            </>
          }
        />
        <CreateWorkflowDialog {...createWorkflow} />
      </Box>

      {numberOfWorkflows && nav ? (
        <>
          {mappedWorkflowMetrics.length && config?.shopifyIntegration ? (
            <Box>
              <Grid
                container
                id="metrics-section"
                spacing={{ xs: 3, md: 5 }}
                columns={{ xs: 12, md: 12 }}
                mb={6}
              >
                {mappedWorkflowMetrics.map((metric) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    key={metric.id}
                    className="workflows-metric"
                  >
                    <MetricCard metric={metric} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            <></>
          )}
          <Box data-tour="workflows-tabs">
            <PageTabs tabValue={tabValue} changeTab={changeTab} nav={nav} />
          </Box>
          <Box data-tour="workflows-list">
            <WorkflowList
              pageName="Workflows"
              bgcolor="white"
              pt={mdUp ? 4 : 3}
              pr={mdUp ? 6 : 4}
              pb={mdUp ? 4 : 3}
              pl={mdUp ? 6 : 4}
              mt={4}
              borderRadius={mdUp ? 2 : 0}
              workflowStatuses={workflowStatuses}
              showChip
            />
          </Box>
        </>
      ) : !isWorkflowsLoading ? (
        <NoWorkflowsPanel
          onCreateWorkflow={handleAddNewWorkflow}
          imgUrl={
            config?.appName === "tinyEmail"
              ? "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/Workflow-email.svg"
              : "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/Workflow-albert.svg"
          }
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default WorkflowsPage;
